<template>
  <sidebar @close="close">
    <template v-slot:head>        
      <div class="container has-text-centered"> 
        <img width="96" height="96" :src="img" />
        <h2 class="title is-4">
          TOTP
        </h2>
      </div>
    </template>
    <template v-slot:body>
      <div class="container has-text-centered" v-if="totp && totp.verified">
        <span>TOTP {{ $t('auth_factors.factor_is_configured') }}</span>
      </div>
      <div class="container has-text-centered" v-else> 
        <div class="field">
          <figure class="avatar">
            <img :src="qr" />
          </figure>
        </div>
        <div class="field">
          <div class="control">
            <input
              class="input"
              type="text"
              :placeholder="$t('auth_factors.one_time_password')"
              value=""
              v-model="passcode"
              autofocus
              @keydown.enter="verify"
            />
          </div>
          <p class="help is-danger has-text-left" v-if="invalid">{{ error }}</p>
        </div>
        <div class="button is-link is-fullwidth" @click="verify">
          <span>{{ $t('auth_factors.verify') }}</span>
        </div>
      </div>
    </template>
    <template v-slot:foot>          
      <div class="container has-text-centered" v-if="totp && totp.verified">
        <a @click="reset">{{ $t('auth_factors.reset') }}</a>   
      </div>
    </template>
  </sidebar>    
</template>

<script>
import totp from "@/services/totp";
import Sidebar from "@/components/Sidebar"
export default {
  name: "TotpDetails",
  components: {
    Sidebar
  },
  props: {
    totp: {
      required: true
    },
    img: {
      required: true
    }
  },
  data() {
    return {
        qr: "",
        passcode: "",
        error: "",
        invalid: false
    };
  },
  created() {
    if (!this.totp) {
      return
    }
    if (this.totp.value === "") {
      totp.initKey().then(
        resp => { 
          this.totp = resp.data;
        },
        err => {
          console.log(err);
        }
      );
    }
  },
  mounted() {
    if (this.totp.verified) {
      return
    }
    this.fetchQR()
  },
  methods: {
    fetchQR() {
      totp.getQr().then(r => {
        this.qr = `data:image/png;base64,${Buffer.from(r.data, 'binary').toString("base64")}`;
        }, err => {
          console.log(err);
      });
    },
    close() {
      this.passcode = "";
      this.error = "";
      this.invalid = false;
      this.$emit("close");
    },
    verify() {
      if (!this.totp) {
        return;
      }
      totp.verifyPass(this.passcode).then(
        () => { 
          this.totp.verified = true;
          this.invalid = false; 
          this.error = "";
          this.$emit("update", this.totp, this.totp.verified);
          this.close();
        },
        err => {
          this.invalid = true;
          this.error = this.$i18n.t('auth_factors.wrong_code');
          console.log(err);
        }
      );
    },
    reset() {
      totp.initKey().then(
        resp => { 
          this.totp = resp.data
          if (!this.totp.verifyed) {
                  this.fetchQR();
          }
          this.$emit("update", this.totp, this.totp.verified)
        },
        err => {
          console.log(err)
        }
      );
    },
  }
};
</script>
